import React, { useState } from 'react';
import { Menu, X, Languages } from 'lucide-react';
import { Button } from './ui/button';
import { useLanguage } from '../context/LanguageContext';
import { translations } from '../translations/translations';

export const Header = () => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const { language, toggleLanguage } = useLanguage();
  const t = translations[language];

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      setMobileMenuOpen(false);
    }
  };

  return (
    <header className="fixed top-0 left-0 right-0 z-50 bg-white/95 backdrop-blur-sm border-b border-gray-200">
      <nav className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-16">
          {/* Logo */}
          <div className="flex-shrink-0">
            <button
              onClick={() => scrollToSection('home')}
              className="hover:opacity-80 transition-opacity">
              <div className="bg-black px-3 py-2 rounded">
                <img
                  src="https://customer-assets.emergentagent.com/job_e89f86fd-ccbb-428c-8bc5-5519914e6241/artifacts/77hlnuis_image.png"
                  alt={language === 'ar' ? 'شعار شركة الحنادس' : 'AL HANADIS COMPANY Logo'}
                  className="h-10 w-auto object-contain" />

              </div>
            </button>
          </div>

          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center space-x-8">
            <button
              onClick={() => scrollToSection('home')}
              className="hover:text-[#61525a] transition-colors !font-medium !px-[15px] text-[#1e1919]">

              {t.home}
            </button>
            <button
              onClick={() => scrollToSection('about')}
              className="hover:text-[#61525a] transition-colors !font-medium !ml-[0px] !pl-[5px] text-[#1e1919]">

              {t.about}
            </button>
            <button
              onClick={() => scrollToSection('products')}
              className="hover:text-[#61525a] transition-colors !font-medium !pr-[10px] text-[#1e1919]">

              {t.products}
            </button>
            <button
              onClick={() => scrollToSection('contact')}
              className="hover:text-[#61525a] transition-colors !font-medium !pl-[10px] text-[#1e1919]">

              {t.contact}
            </button>
            
            {/* Language Toggle */}
            <Button
              variant="outline"
              size="sm"
              onClick={toggleLanguage}
              className="flex items-center space-x-2">

              <Languages className="h-4 w-4" />
              <span>{language === 'en' ? 'AR' : 'EN'}</span>
            </Button>
          </div>

          {/* Mobile menu button */}
          <div className="md:hidden flex items-center space-x-2">
            <Button
              variant="outline"
              size="sm"
              onClick={toggleLanguage}
              className="flex items-center space-x-1">

              <Languages className="h-4 w-4" />
              <span className="text-xs">{language === 'en' ? 'AR' : 'EN'}</span>
            </Button>
            <Button
              variant="ghost"
              size="icon"
              onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
              aria-label="Toggle menu">

              {mobileMenuOpen ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
            </Button>
          </div>
        </div>

        {/* Mobile Navigation */}
        {mobileMenuOpen &&
        <div className="md:hidden py-4 border-t border-gray-200">
            <div className="flex flex-col space-y-4">
              <button
              onClick={() => scrollToSection('home')}
              className="text-[#1e1919] hover:text-[#61525a] transition-colors font-medium text-left">

                {t.home}
              </button>
              <button
              onClick={() => scrollToSection('about')}
              className="text-[#1e1919] hover:text-[#61525a] transition-colors font-medium text-left">

                {t.about}
              </button>
              <button
              onClick={() => scrollToSection('products')}
              className="text-[#1e1919] hover:text-[#61525a] transition-colors font-medium text-left">

                {t.products}
              </button>
              <button
              onClick={() => scrollToSection('contact')}
              className="text-[#1e1919] hover:text-[#61525a] transition-colors font-medium text-left">

                {t.contact}
              </button>
            </div>
          </div>
        }
      </nav>
    </header>);

};